


















import { defineComponent } from '@nuxtjs/composition-api';
import BaseButton from '@shared/components/@atoms/BaseButton/BaseButton.vue';
// @ts-ignore migrated from ui-library
import Simplebar from 'simplebar-vue';
export default defineComponent({
  name: 'BaseScrollable',
  components: {
    BaseButton,
    Simplebar,
  },
  props: {
    maxContentHeight: {
      type: String,
      default: '',
    },
    showText: {
      type: String,
      default: 'Show',
    },
    hideText: {
      type: String,
      default: 'Hide',
    },
  },
  data() {
    return {
      isHidden: true,
      hasScroll: false,
      contentEl: undefined,
    };
  },
  computed: {
    style(): any {
      return {
        '--_scrollable-max-height': this.maxContentHeight.trim()
          ? this.maxContentHeight
          : undefined,
      };
    },
    ariaLabel(): any {
      // @ts-ignore migrated from ui-library
      const showAll = this.showText?.trim() || 'Show all';
      // @ts-ignore migrated from ui-library
      const hideAll = this.hideText?.trim() || 'Hide all';
      // @ts-ignore migrated from ui-library
      return this.isHidden ? `${showAll}` : `${hideAll}`;
    },
  },
  mounted() {
    this.$nextTick(() => {
      // @ts-ignore migrated from ui-library
      this.contentEl = this.$refs.content.$el.querySelector('.simplebar-content');
      if (typeof MutationObserver === 'undefined' || !this.contentEl) return;
      const observer = new MutationObserver(this.sizeCalc);
      this.sizeCalc();
      // @ts-ignore migrated from ui-library
      observer.observe(this.contentEl, { childList: true });
    });
  },
  methods: {
    sizeCalc() {
      // @ts-ignore migrated from ui-library
      const containerHeight = this.$refs.content.$el.offsetHeight;
      // @ts-ignore migrated from ui-library
      const contentHeight = this.contentEl.offsetHeight;
      this.hasScroll = contentHeight > containerHeight;
    },
  },
});
